import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import GS from '../../grafsync/grafsync';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../withGShoc';
import { isRTL, makeCancelable } from '../utils/utils';
import Errored from '../Errored';

class ResourceLorem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isErrored: undefined
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.retrieveXlLabels();
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    loadData(data, options) {
        this.cancellable = makeCancelable(GS.loadData(data, options, this.props.graph, false));
        return this.cancellable;
    }

    // We need to compute entailment for any XL labels
    async retrieveXlLabels() {
        try {
            const { data, property } = this.props;
            if (![
                "http://www.w3.org/2004/02/skos/core#altLabel",
                "http://www.w3.org/2004/02/skos/core#hiddenLabel",
                "http://www.w3.org/2004/02/skos/core#prefLabel"].includes(property)) return;
            const alias = GS.getAlias(property);
            const propName = "xl" + alias.charAt(0).toUpperCase() + alias.slice(1);
            let xlResources = data[propName] ? data[propName] : [];
            if (xlResources.length > 0) {
                const labelLoadOptions = {
                    predicates: [
                        "http://www.w3.org/2008/05/skos-xl#literalForm",
                        "http://www.w3.org/2004/02/skos/core#inScheme",
                        "https://grafsync.graphifi.com/schema/gs/status"
                    ]
                };
                GS.handle("retrieve-examples");
                await this.loadData(xlResources, labelLoadOptions, false).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                // Now that we have loaded any XL labels we force entailment to compute alt and hidden labels
                // Pref labels would already have been computed potentially
                GS.computeEntailment([{
                    iri: data.id,
                    graph: this.props.graph
                }]);
            }
        }
        catch (e) {
            if (this.cancellable && this.cancellable.isCancelled()) return;
            this.setState({ isErrored: e });
        }
    }

    render() {

        const { data, lang, property, labelProp, showLang } = this.props;
        const { isErrored } = this.state;
        const alias = GS.getAlias(property) || property;
        const rtl = showLang && isRTL(lang);

        if (isErrored) return <Errored dataTest="rl-error" data={isErrored} />;

        return (
            <Typography
                dir={rtl ? "rtl" : null}
                lang={showLang ? lang : null}
                variant="body2"
                style={{ fontSize: 12 }}>
                <span style={{ display: 'inline-block', width: 205, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {
                        alias === "type" ?
                            Array.isArray(data[alias]) ?
                                data[alias].filter(classType => data[alias].length === 1 || classType !== "Concept")[0]
                                :
                                data[alias]
                            :
                            property === "https://grafsync.graphifi.com/schema/tsv/hierarchy"
                                || property === "https://grafsync.graphifi.com/schema/tsv/concepts"
                                || property === "https://grafsync.graphifi.com/schema/tsv/resources" ?
                                data[labelProp] && data[labelProp][lang] ?
                                    Array.isArray(data[labelProp][lang]) ?
                                        data[labelProp][lang].sort().join(",")
                                        :
                                        data[labelProp][lang]
                                    :
                                    "No value available"
                                :
                                property === "https://grafsync.graphifi.com/schema/tsv/IRI" ?
                                    <Tooltip title={data.id}>
                                        <span>{data.id}</span>
                                    </Tooltip>
                                    :
                                    alias in data ?
                                        Array.isArray(data[alias]) ?
                                            data[alias][0]["language"] ?
                                                data[alias].some(item => item.language === lang) ?
                                                    data[alias].find(item => item.language === lang)["@value"]
                                                    :
                                                    null
                                                :
                                                data[alias][0]["@value"] ?
                                                    data[alias][0]["@value"]
                                                    :
                                                    data[alias][0].id ?
                                                        <Tooltip title={data[alias][0].id}>
                                                            <span>{data[alias][0].id}</span>
                                                        </Tooltip>
                                                        :
                                                        data[alias][0]
                                            :
                                            typeof data[alias] === "boolean" ?
                                                data[alias] === true ?
                                                    "TRUE"
                                                    :
                                                    "FALSE"
                                                :
                                                data[alias]["@value"] ?
                                                    data[alias]["@value"]
                                                    :
                                                    lang ?
                                                        data[alias][lang] ?
                                                            Array.isArray(data[alias][lang]) ?
                                                                data[alias][lang][0]
                                                                :
                                                                data[alias][lang]
                                                            :
                                                            typeof data[alias] === "string" ?
                                                                data[alias]
                                                                :
                                                                null
                                                        :
                                                        typeof data[alias] === "string" ?
                                                            data[alias]
                                                            :
                                                            null
                                        :
                                        null
                    }
                </span>
            </Typography>
        );
    }
}

ResourceLorem.propTypes = {
    labelProp: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    property: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    showLang: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired
};

export default withGS(ResourceLorem, ["ALL"], null, {}, true);